import React from 'react';
import { observer } from 'mobx-react';
import TestPath from 'app/views/synthetics/components/TestPath';
import LoadingPanel from './LoadingPanel';

@observer
export default class PathPanel extends React.Component {
  render() {
    const { test, testResults, traceroutes, agents } = this.props;
    const { loadingAlarmResults, loadingTraceResults, displayOptions, hasTraceResults } = testResults;
    const { allowExport } = displayOptions;
    const isParentTest = !agents; // subtest trace results explicit provide the agent id

    return (
      <LoadingPanel
        test={test}
        testResults={testResults}
        // since parent tests also consider agents and targets associated with alarms, we wait for that too
        loading={(isParentTest && loadingAlarmResults) || (loadingTraceResults && !hasTraceResults)}
      >
        <TestPath
          testResults={testResults}
          traceroutes={traceroutes}
          agents={agents || test.get('config.agents') || []}
          isPreview={test.isPreview}
          allowExport={allowExport}
        />
      </LoadingPanel>
    );
  }
}
